module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product && _vm.product.badges.length) ? _c('div', {
    staticClass: "product-badges",
    class: {
      'border-none': (_vm.product.labels && _vm.product.labels.length)
    }
  }, _vm._l((_vm.product.badges), function(badge, index) {
    return _c('div', {
      staticClass: "badges-item",
      style: ({
        'color': badge.color
      }),
      on: {
        "click": function($event) {
          return _vm.jump(badge)
        }
      }
    }, [(index !== 0) ? _c('div', {
      staticClass: "circle"
    }, [_vm._v("·")]) : _vm._e(), _vm._v("\n    " + _vm._s(badge.text) + "\n  ")])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af603c6c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/product-badges.vue
// module id = 1030
// module chunks = 2